module.exports = __webpack_public_path__ + "static/media/bg-dude.72729f1d.png";